import { useState } from "react";

import { addDays, startOfWeek } from "date-fns";

import { useAppointmentsQuery } from "@/common/hooks/useAppointmentsQuery";

interface DateRange {
  startDate: Date;
  endDate: Date;
}

export function useAppointmentsWeek(selectedCounselorId: string | null) {
  const [dateRange, setDateRange] = useState<DateRange>(() => {
    const weekStart = startOfWeek(new Date(), { weekStartsOn: 1 });
    return {
      startDate: weekStart,
      endDate: addDays(weekStart, 7),
    };
  });

  const { calendarAppointments, attendanceAppointments, isLoading } = useAppointmentsQuery({
    startDate: dateRange.startDate,
    endDate: dateRange.endDate,
    counselorId: selectedCounselorId,
  });

  const onDateRangeChange = (start: Date, end: Date) => {
    setDateRange({ startDate: start, endDate: end });
  };

  return {
    calendarAppointments,
    attendanceAppointments,
    isLoading,
    onDateRangeChange,
  };
}
